import { match } from 'ts-pattern'
import { FitpetMallEventEnum } from '@/constants/fitpet-mall-event.enum'
import ROUTES from '@/constants/legacy/constRoutes'
import { useTracker } from '@/containers/contexts/EventTrackingProvider'
import type { ProductsListItemResponseDto } from '@/apis/rest/generated/types'

const getLocation = (prevPath?: string, tabClick?: string) => {
  return match({ prevPath, tabClick })
    .with({ prevPath: ROUTES.INDEX }, () => 'main')
    .with({ prevPath: ROUTES.MYPAGE.BASE }, () => 'mypage')
    .with({ prevPath: ROUTES.CART, tabClick: 'like' }, () => 'cart')
    .with({ tabClick: 'view' }, () => 'favorite')
    .with({ tabClick: 'like' }, () => 'favorite')
    .otherwise(() => undefined)
}

export const useFavoritesEventTracker = () => {
  const tracker = useTracker()

  // 관심상품 페이지 view 이벤트
  const trackViewFavoritePageEventB = ({
    productList,
    addLocation,
    tabName,
    prevPath,
    tabClick,
  }: {
    productList: ProductsListItemResponseDto[]
    addLocation: 'favorite_recentproduct' | 'favorite_likeproduct'
    tabName: string
    prevPath?: string
    tabClick?: string
  }) => {
    const nudgeProductIds = productList.filter((product) => product.isPriceDown).map((product) => product.id)
    const noNudgeProductIds = productList.filter((product) => !product.isPriceDown).map((product) => product.id)

    const properties = {
      ab_test_group: 'favorite_downnudge_b',
      product_ids: productList.map((product) => product.id),
      total_product_cnt: productList.length,
      add_location: addLocation,
      tab_name: tabName,
      nudge_product_cnt: nudgeProductIds.length,
      nudge_product_ids: nudgeProductIds,
      no_nudge_product_cnt: noNudgeProductIds.length,
      no_nudge_product_ids: noNudgeProductIds,
      is_direct_result: tabClick === undefined,
      location: getLocation(prevPath, tabClick),
    }
    tracker.triggerCustomEvent(FitpetMallEventEnum.ViewFavoritePage, properties)
  }

  // 관심상품 페이지 product click 이벤트
  const trackRecentlyProductClickEvent = ({
    productId,
    productName,
    productPrice,
    salePrice,
    reviewScore,
    reviewCount,
    listIndex,
    isNudge,
  }: {
    productId: number
    productName: string
    productPrice: number
    salePrice: number
    reviewScore?: number
    reviewCount?: number
    listIndex: number
    isNudge?: boolean
  }) => {
    const properties = {
      listIndex,
      product_id: productId,
      product_name: productName,
      product_price: productPrice,
      product_purchase_price: salePrice,
      product_review_avg_score: reviewScore,
      product_review_total_count: reviewCount,
      is_nudge: isNudge,
    }
    tracker.triggerCustomEvent(FitpetMallEventEnum.ClickRecentlyProduct, properties)
  }

  return {
    trackViewFavoritePageEventB,
    trackRecentlyProductClickEvent,
  }
}
